import { Menu as MenuIcon } from '@mui/icons-material';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { clearSession } from '@/lib/auth-session';
import { useSyncStatus } from '@/lib/hooks/useSyncStatus';
import { useAuthStore } from '@/store/authStore';
import { useUiStore } from '@/store/uiStore';

import { GlobalSearch } from './GlobalSearch';
import { HelpMenu } from './HelpMenu';
import { Logo } from './Logo';
import { SyncStatus } from './SyncStatus';

export function Header() {
  const navigate = useNavigate();
  const staff = useAuthStore((s) => s.staff);
  const { lastSyncedAt } = useSyncStatus();
  const openMobileSidebar = useUiStore((s) => s.openMobileSidebar);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleLogout = (): void => {
    // 토큰만 지우면 이전 계정의 조회 캐시가 남는다 — clearSession 주석 참고
    clearSession();
    navigate('/login', { replace: true });
  };

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}
      color="default"
      elevation={0}
    >
      <Toolbar sx={{ gap: { xs: 1, md: 3 } }}>
        {isMobile && (
          <IconButton edge="start" onClick={openMobileSidebar} aria-label="메뉴 열기">
            <MenuIcon />
          </IconButton>
        )}
        <Logo />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <GlobalSearch />
        </Box>
        <Stack direction="row" spacing={{ xs: 1, md: 3 }} alignItems="center">
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <SyncStatus lastSyncedAt={lastSyncedAt} />
          </Box>
          <HelpMenu />
          {staff && (
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Stack alignItems="flex-end" sx={{ lineHeight: 1.2 }}>
                <Typography variant="body2" fontWeight={600} noWrap>
                  {staff.nickname}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap>
                  {staff.role}
                </Typography>
              </Stack>
              <Button size="small" variant="outlined" onClick={handleLogout}>
                로그아웃
              </Button>
            </Stack>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
